// Wrapper fo GA4

function gaOptout() {
    var gaProperty = 'G-V8Y1LCT2XF';
    var disableStr = 'ga-disable-' + gaProperty;
    document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    window[disableStr] = true;
    alert('GoogleAnalytics disabled');
}

mp.analytics = {
    retryPV: 250, // Wiederholungsversuch in X Millisekunden für Pageview
    retryDM: 200, // Wiederholungsversuch in X Millisekunden für Dimensions

    init: function () {
        // Ergebnislisten, 404-Seite mit Suchergebnis statt dem nicht mehr verfügbaren OfferDetail
        if ($('#mpFallback404').length > 0) {
            mp.analytics.deletedOffer404();
        }

        // Tracking-Data-Types (inkl. spezifischen Events für schnelle Dashboardansicht)
        $(document).on('click', '[data-tracking]', function () {
            var ref = $(this);
            try {
                mp.analytics[ref.data('tracking')](ref.data('tracking-ident'));
            } catch (e) {
                console.log(e);
            }
        });
        $('#mpHeaderSearchForm').on('submit', function() {
            try {
                mp.analytics.headerSearchFormSubmit();
            } catch (e) {
                console.log(e);
            }
        });
    },

    event: function (category, action, label) {
        if (mp.analytics.check()) {
            setTimeout(function () {
                mp.analytics.eventExec(category, action, label);
            }, 23); // initialer Versatz nach erfolgreicher Initialisierung
        } else {
            setTimeout(function () {
                mp.analytics.eventExec(category, action, label);
            }, mp.analytics.retryPV);
        }
    },
    // nicht direkt ausführen!
    eventExec: function (category, action, label) {
        gtag('event', action, {
            'event_category': category,
            'event_label': label
        });
    },

    // Info: Die Events sind als zusätzliche Anischtshilfe gedacht - die eigentliche Statistik-Klassifizierung kommt via custom dimensions
    vendorContactOpen: function (val) {
        if (mp.analytics.check()) {
            mp.analytics.event('vendorContact', 'open', val);
        } else {
            setTimeout(function (val) {
                mp.analytics.vendorContactOpen(val);
            }, mp.analytics.retryDM);
        }
    },
    vendorContactSuccess: function (val) {
        if (mp.analytics.check()) {
            mp.analytics.event('vendorContact', 'success', val);
        } else {
            setTimeout(function (val) {
                mp.analytics.vendorContactSuccess(val);
            }, mp.analytics.retryDM);
        }
    },
    vendorPhone: function (val) {
        if (mp.analytics.check()) {
            mp.analytics.event('vendorPhone', 'click', val);
        } else {
            setTimeout(function (val) {
                mp.analytics.vendorPhone(val);
            }, mp.analytics.retryDM);
        }
    },
    generatePdfOpen: function (val) {
        if (mp.analytics.check()) {
            mp.analytics.event('generatePdf', 'open', val);
        } else {
            setTimeout(function (val) {
                mp.analytics.generatePdfOpen(val);
            }, mp.analytics.retryDM);
        }
    },
    generatePdfDownload: function (val) {
        if (mp.analytics.check()) {
            mp.analytics.event('generatePdf', 'download', val);
        } else {
            setTimeout(function (val) {
                mp.analytics.generatePdfDownload(val);
            }, mp.analytics.retryDM);
        }
    },
    offerRecommend: function (val) {
        if (mp.analytics.check()) {
            mp.analytics.event('offerRecommend', 'click', val);
        } else {
            setTimeout(function (val) {
                mp.analytics.offerRecommend(val);
            }, mp.analytics.retryDM);
        }
    },
    deletedOffer404: function () {
        if (mp.analytics.check()) {
            mp.analytics.event('offerDeleted', 'autosearch', document.location.pathname);
        } else {
            setTimeout(mp.analytics.deletedOffer404, mp.analytics.retryDM);
        }
    },

    headerSearchImage: function (val) {
        if (mp.analytics.check()) {
            mp.analytics.event('headerSearch', 'clickImage', val);
            mp.analytics.event('headerSearch', 'searchTermAtClickImage', mp.autocomplete.currentTerm);
        } else {
            setTimeout(function (val) {
                mp.analytics.headerSearchImage(val);
            }, mp.analytics.retryDM);
        }
    },
    headerSearch: function (val) {
        if (mp.analytics.check()) {
            mp.analytics.event('headerSearch', 'clickLink', val);
            mp.analytics.event('headerSearch', 'searchTermAtClickLink', mp.autocomplete.currentTerm);
        } else {
            setTimeout(function (val) {
                mp.analytics.headerSearch(val);
            }, mp.analytics.retryDM);
        }
    },
    headerSearchLinkSubmit: function (val) {
        if (mp.analytics.check()) {
            mp.analytics.event('headerSearch', 'linkSubmit', mp.autocomplete.currentTerm);
        } else {
            setTimeout(function () {
                mp.analytics.headerSearchLinkSubmit(null);
            }, mp.analytics.retryDM);
        }
    },
    headerSearchFormSubmit: function (val) {
        if (mp.analytics.check()) {
            mp.analytics.event('headerSearch', 'formSubmit', mp.autocomplete.currentTerm);
        } else {
            setTimeout(function () {
                mp.analytics.headerSearchFormSubmit(null);
            }, mp.analytics.retryDM);
        }
    },
    loadPage: function (url) {
        if (mp.analytics.check()) {
            mp.analytics.event('loadPage', 'load', url);
        } else {
            setTimeout(mp.analytics.loadPage, mp.analytics.retryDM);
        }
    },

    check: function () {
        if (typeof(gtag) === 'function') {
            return true;
        }
        return false;
    }
};

$(document).ready(function () {
    if (Cookies.get('MP_Dsgvo') === 'accepted') {
        mp.analytics.init();
    }
});